import { render } from "./RedesSociales.vue?vue&type=template&id=37e28d62"
import script from "./RedesSociales.js?vue&type=script&lang=js&external"
export * from "./RedesSociales.js?vue&type=script&lang=js&external"

import "./RedesSociales.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__